// Mock data for TUM HOLIDAYS

export const domesticPackages = [
  {
    id: 1,
    name: "Spiti Valley Backpacking",
    duration: "8N/9D",
    departure: "Delhi - Delhi",
    price: 18999,
    image: "https://customer-assets.emergentagent.com/job_1c7269e2-1feb-426d-b007-6b7d8cae6132/artifacts/lasr2wry_Spiti%20Tum.jpeg",
    highlights: ["Kaza", "Key Monastery", "Chandratal Lake", "Pin Valley"],
    availableDates: "Every Saturday",
    type: "backpacking"
  },
  {
    id: 2,
    name: "Leh Ladakh Adventure",
    duration: "6N/7D",
    departure: "Delhi - Delhi",
    price: 24999,
    image: "https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=800",
    highlights: ["Pangong Lake", "Nubra Valley", "Khardung La", "Leh Palace"],
    availableDates: "Every Saturday",
    type: "backpacking"
  },
  {
    id: 3,
    name: "Kerala Backwaters",
    duration: "5N/6D",
    departure: "Cochin",
    price: 15999,
    image: "https://images.unsplash.com/photo-1602216056096-3b40cc0c9944?w=800",
    highlights: ["Houseboat Stay", "Alleppey", "Munnar", "Thekkady"],
    availableDates: "Daily",
    type: "standard"
  },
  {
    id: 4,
    name: "Rajasthan Heritage Tour",
    duration: "7N/8D",
    departure: "Delhi",
    price: 22999,
    image: "https://images.unsplash.com/photo-1599661046289-e31897846e41?w=800",
    highlights: ["Jaipur", "Udaipur", "Jaisalmer", "Jodhpur"],
    availableDates: "Weekly",
    type: "standard"
  },
  {
    id: 5,
    name: "Goa Beach Paradise",
    duration: "4N/5D",
    departure: "Goa",
    price: 12999,
    image: "https://images.unsplash.com/photo-1587693266767-4c0a2c5c6c5e?w=800",
    highlights: ["North Goa Beaches", "Water Sports", "Night Parties", "South Goa"],
    availableDates: "Daily",
    type: "standard"
  },
  {
    id: 6,
    name: "Himachal Hill Stations",
    duration: "6N/7D",
    departure: "Delhi",
    price: 16999,
    image: "https://images.unsplash.com/photo-1626621341517-4598db9bf3f0?w=800",
    highlights: ["Shimla", "Manali", "Rohtang Pass", "Solang Valley"],
    availableDates: "Daily",
    type: "standard"
  }
];

export const internationalPackages = [
  {
    id: 7,
    name: "Bali Paradise",
    duration: "5N/6D",
    departure: "Delhi",
    price: 45999,
    image: "https://customer-assets.emergentagent.com/job_1c7269e2-1feb-426d-b007-6b7d8cae6132/artifacts/lj6mt1in_Bali%20Tum.jpeg",
    highlights: ["Ubud Rice Terraces", "Tanah Lot Temple", "Beach Clubs", "Water Temples"],
    availableDates: "Weekly",
    type: "international"
  },
  {
    id: 8,
    name: "Dubai Luxury",
    duration: "4N/5D",
    departure: "Delhi/Mumbai",
    price: 38999,
    image: "https://images.unsplash.com/photo-1512453979798-5ea266f8880c?w=800",
    highlights: ["Burj Khalifa", "Desert Safari", "Dubai Mall", "Marina Cruise"],
    availableDates: "Daily",
    type: "international"
  },
  {
    id: 9,
    name: "Thailand Adventure",
    duration: "6N/7D",
    departure: "Delhi/Mumbai",
    price: 42999,
    image: "https://images.unsplash.com/photo-1552465011-b4e21bf6e79a?w=800",
    highlights: ["Bangkok", "Pattaya", "Phi Phi Islands", "James Bond Island"],
    availableDates: "Weekly",
    type: "international"
  },
  {
    id: 10,
    name: "Singapore & Malaysia",
    duration: "6N/7D",
    departure: "Delhi/Mumbai",
    price: 52999,
    image: "https://images.unsplash.com/photo-1525625293386-3f8f99389edd?w=800",
    highlights: ["Universal Studios", "Gardens by the Bay", "Genting Highlands", "Twin Towers"],
    availableDates: "Weekly",
    type: "international"
  },
  {
    id: 11,
    name: "Maldives Honeymoon",
    duration: "4N/5D",
    departure: "Delhi/Mumbai",
    price: 89999,
    image: "https://images.unsplash.com/photo-1514282401047-d79a71a590e8?w=800",
    highlights: ["Water Villa", "Snorkeling", "Beach Dining", "Spa Treatments"],
    availableDates: "Daily",
    type: "international"
  },
  {
    id: 12,
    name: "Sri Lanka Explorer",
    duration: "5N/6D",
    departure: "Delhi/Mumbai",
    price: 35999,
    image: "https://images.unsplash.com/photo-1566073771259-6a8506099945?w=800",
    highlights: ["Sigiriya Rock", "Kandy Temple", "Tea Plantations", "Beaches"],
    availableDates: "Weekly",
    type: "international"
  }
];

export const activities = [
  { id: 1, name: "Paragliding", location: "Bir Billing", price: 2500 },
  { id: 2, name: "River Rafting", location: "Rishikesh", price: 1500 },
  { id: 3, name: "Scuba Diving", location: "Andaman", price: 3500 },
  { id: 4, name: "Bungee Jumping", location: "Rishikesh", price: 3500 }
];

export const testimonials = [
  {
    id: 1,
    name: "Priya Sharma",
    location: "Delhi",
    rating: 5,
    comment: "Amazing Spiti Valley trip! TUM Holidays made everything so smooth and hassle-free. Highly recommended!",
    image: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=150"
  },
  {
    id: 2,
    name: "Rahul Verma",
    location: "Mumbai",
    rating: 5,
    comment: "Best Bali package ever! The team was very professional and the itinerary was perfect.",
    image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150"
  },
  {
    id: 3,
    name: "Sneha Reddy",
    location: "Bangalore",
    rating: 5,
    comment: "Leh Ladakh backpacking trip was a dream come true! Thank you TUM Holidays for the memories.",
    image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150"
  }
];

export const services = [
  {
    id: 1,
    title: "Tour Packages",
    description: "Curated domestic and international tour packages",
    icon: "Palmtree"
  },
  {
    id: 2,
    title: "Flight Booking",
    description: "Best deals on domestic and international flights",
    icon: "Plane"
  },
  {
    id: 3,
    title: "Cab Services",
    description: "Comfortable and reliable cab services",
    icon: "Car"
  },
  {
    id: 4,
    title: "Activities",
    description: "Adventure activities and experiences",
    icon: "Mountain"
  },
  {
    id: 5,
    title: "Tourist Visa",
    description: "Hassle-free visa assistance",
    icon: "FileText"
  },
  {
    id: 6,
    title: "Hotel Booking",
    description: "Best accommodation at great prices",
    icon: "Hotel"
  }
];